export const ROOT_TEST_ID = 'OfferPreviewBalloon';
export const SLOT_TEST_ID = 'OfferPreviewBalloonSlot';
// Нулевой тик ждёт, пока ymaps вставит layout в DOM после balloon.open()
export const WAIT_LAYOUT_TICK_MS = 0;
// Пилюля выбранного кликом пина (BalloonManager помечает её data-is-selected — только isActive,
// без hover, в отличие от data-is-active) — по ней меряем реальную ширину для центрирования превью
export const ACTIVE_PIN_SELECTOR = '[data-testid="pin"][data-is-selected="true"]';
// Сколько кадров ждать перекраски активной пилюли ObjectManager'ом перед уточнением центрирования
export const REFINE_TRANSFORM_MAX_FRAMES = 5;
